import { useState, useEffect } from 'react';

export default function FloatingCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      // Aparece pasado 400px
      const show = scrollY > 400;

      // Se oculta cuando el usuario llega cerca de la sección de contacto
      const contactSection = document.getElementById('contacto');
      let nearContact = false;
      if (contactSection) {
        const rect = contactSection.getBoundingClientRect();
        nearContact = rect.top < window.innerHeight * 0.6;
      }

      setVisible(show && !nearContact);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    const contactSection = document.getElementById('contacto');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      className={`fixed bottom-8 left-1/2 z-[9990] transition-all duration-500 ${
        visible
          ? 'opacity-100 translate-y-0 -translate-x-1/2'
          : 'opacity-0 translate-y-6 -translate-x-1/2 pointer-events-none'
      }`}
    >
      <button
        onClick={handleClick}
        aria-label="Solicita tu primera consulta gratuita"
        className="
          group flex items-center gap-3 cursor-pointer
          bg-[#1B3A5C] hover:bg-[#16304e]
          text-white text-sm font-semibold tracking-wide whitespace-nowrap
          pl-5 pr-6 py-3.5 rounded-full
          transition-all duration-300 hover:scale-105
        "
        style={{ boxShadow: '0 8px 32px rgba(27,58,92,0.35)' }}
      >
        {/* Icono */}
        <span className="w-7 h-7 flex items-center justify-center rounded-full bg-[#3D9E8C] group-hover:bg-[#359080] transition-colors duration-300 shrink-0">
          <i className="ri-calendar-check-line text-white text-sm" />
        </span>

        {/* Texto */}
        <span>Solicita tu primera consulta <span className="text-[#3D9E8C]">gratuita</span></span>

        {/* Flecha */}
        <i className="ri-arrow-right-line text-[#3D9E8C] text-base transition-transform duration-300 group-hover:translate-x-1" />
      </button>
    </div>
  );
}
